module.exports = "data:image/gif;base64,R0lGODdhAQABAPAAAO7u7gAAACwAAAAAAQABAAACAkQBADs="